// Pure, bounded path analysis shared by publishing validation and admin health.
export const MAGNET_HEALTH_RULE_VERSION = 'completion-v1';
export const MAX_FLOW_STEPS = 500;
const CONTACT_FIELDS = new Set(['name', 'first_name', 'last_name', 'email', 'phone', 'mobile']);

// Call after structural validation. Separate path states prevent a contact question
// on one branch from contaminating an unrelated informational exit.
export function nonSubmittingExits(steps) {
  if (!Array.isArray(steps) || !steps.length || steps.length > MAX_FLOW_STEPS) return [];
  const ids = new Map(steps.map((s, i) => [String(s.id ?? ''), i]));
  const queue = [{ index: 0, kind: 0, path: [] }], seen = new Set(), exits = new Map();
  for (let head = 0; head < queue.length; head++) {
    const state = queue[head], step = steps[state.index];
    if (!step) continue;
    const columns = step.step_type === 'message' ? [] : (step.step_columns || []);
    const contact = ['email', 'phone'].includes(step.step_type) || columns.some(k => CONTACT_FIELDS.has(k));
    const input = ['text', 'scheduler'].includes(step.step_type);
    const kind = Math.max(state.kind, contact ? 2 : input ? 1 : 0);
    const key = `${state.index}:${kind}`;
    if (seen.has(key)) continue;
    seen.add(key);
    const path = [...state.path, state.index + 1];
    if (step.step_type === 'message' && step.step_config?.terminal) {
      if (!exits.has(state.index) || kind > exits.get(state.index).kind) exits.set(state.index, { index: state.index, kind, path });
      continue;
    }
    const next = state.index + 1 < steps.length ? [state.index + 1] : [];
    const edges = step.step_type === 'single_select'
      ? (step.step_options || []).flatMap(o => o.goto != null && String(o.goto) !== '' ? [ids.get(String(o.goto))] : next) : next;
    if (step.step_type === 'single_select' && step.step_config?.skip_if_prefilled) edges.push(...next);
    for (const index of new Set(edges)) if (Number.isInteger(index)) queue.push({ index, kind, path });
  }
  return [...exits.values()].map(exit => ({ ...exit,
    code: exit.kind === 2 ? 'unsent_contact' : exit.kind === 1 ? 'unsent_input' : 'informational_exit',
    message: exit.kind === 2
      ? `Step ${exit.index + 1}: this path collects contact details, then ends without sending them. Turn off “Informational exit” so the flow can continue to review or submission.`
      : exit.kind === 1 ? `Step ${exit.index + 1}: this path collects an answer, then ends without submitting it. Review whether that is intended.`
        : `Step ${exit.index + 1}: informational exit; no typed answers collected on this path.`,
    field: 'terminal',
  }));
}
